var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"projects-page"}},[_c('PageTitle',{attrs:{"title":"Список фильтров","icon":""}}),_c('FiltersList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }